import $ from 'jquery'
import Cookies from 'js-cookie'
import 'lightbox2/dist/js/lightbox'

// POLYFILL
import './polyfill'

// IE 11 optimalizace
import 'core-js/es/object'
import 'core-js/es/string'
import 'core-js/es/array'
import 'core-js/es/map'
import 'core-js/es/weak-map'
import 'core-js/es/weak-set'

/* TypeScript */
import { App } from './app'
import { Loader } from './component'

import * as appFunctions from './$_functions'
import { number } from './utils'

window.jQuery = $
window.$ = $
window.Cookies = Cookies

// App functions
window.show = appFunctions.show
window.debounce = appFunctions.debounce
window.makeDebounceAjaxCall = appFunctions.makeDebounceAjaxCall
window.Loader = Loader
window.formatNumber = number.formatNumber

const clientIDs = {};

window['g_onRecaptchaLoad'] = function () {
    $('.g-recaptcha').each(function () {
        const el = $(this);

        clientIDs[this.id] = grecaptcha.render(this, {
            size: 'invisible',
            badge: 'inline',
            callback: function (token) {
                el.closest('form').off('submit.recaptcha').trigger('submit');
            }

        }, true);
    });

    $(function () {
        $('form').on('submit.recaptcha', function (event) {
            event.preventDefault();

            const form = $(this);
            if (Nette.validateForm(this, true)) {
                // execute only reCAPTCHAs in submitted form
                $('.g-recaptcha', form).each(function () {
                    grecaptcha.execute(clientIDs[this.id]);
                });
            }
        });
    });
};

/**
 * Create new ELIS scripts instance -> Init
 */
try {
    const app = App()
    app.init()
} catch (e) {
    throw Error(e)
}
